import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { DotGrid } from "@/components/shared/dot-grid"
import { AuthLevel, getAuthLevel } from "@/lib/auth"
import { REQUIRE_MFA } from "@/lib/constants"
import { supabase } from "@/lib/supabase"

export const Route = createFileRoute("/_auth")({
	beforeLoad: async () => {
		const {
			data: { session },
		} = await supabase.auth.getSession()

		if (!session) return

		if (REQUIRE_MFA) {
			const authLevel = await getAuthLevel()
			if (authLevel === AuthLevel.FullyAuthenticated) {
				throw redirect({ to: "/" })
			}
		} else {
			throw redirect({ to: "/" })
		}
	},
	component: AuthLayout,
})

function AuthLayout() {
	return (
		<div className="relative flex min-h-screen items-center justify-center bg-muted dark:bg-background">
			<DotGrid className="pointer-events-none absolute inset-0" />
			<div className="relative z-10 w-full max-w-sm">
				<Outlet />
			</div>
		</div>
	)
}
